import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BlockUi from "react-block-ui";
import _ from "lodash";
import { Grid, Typography, CardContent, Box, Button } from "@mui/material";
import OrderService from "../../Services/OrderService";
import TopBar from "../Common/TopBar";
import ErrorBoundary from "../Common/ErrorBoundary";
import ReturnOrderStatusIcons from "./ReturnOrderStatusIcons";
import ReturnOrderDetailCard from "../Common/ReturnOrderDetailCard";
import NeedHelp from "../Common/NeedHelp";
import CommonConstantValues from "../../Services/CommonConstantValues";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import AnalyticsService from "../../Services/AnalyticsService";
import ConfirmationModal from "../Common/ConfirmationModal";
import DocumentService from "../../Services/DocumentService";
import AgentService from "../../Services/AgentService";
import Toast from "../Common/Toast";
import MiscUtils from "../../Utils/MiscUtils";
import { makeStyles } from "@mui/styles";
import FileUploadDrawer from "../FieldAgent/FileUploadDrawer";
import AndroidService from "../../Services/AndroidService";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

const useStyles = makeStyles({
  addBiltyButton: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "50px",
    background: "#9D2123",
    color: "white",
    borderRadius: 0,
    "&:hover": {
      backgroundColor: "#9D2123",
    },
    maxWidth: "600px",
  },
});

function ReturnOrderDetails() {
  const query = new URLSearchParams(window.location.search);
  const returnOrderID = query.get("returnOrderId");
  const [orderDetails, setOrderDetails] = useState([]);
  const [loading, setLoading] = useState(CommonConstantValues.NOT_STARTED);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const styleClass = useStyles();
  const [showFileUpload, setShowFileUpload] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("createReturnInitiated")) {
      localStorage.removeItem("createReturnInitiated");
    }
    localStorage.setItem("visitedReturnOrderDetailsPage", true);
    const returnOrderDetailCB = getReturnOrderDetail();
    return returnOrderDetailCB;
  }, []);

  const getReturnOrderDetail = () => {
    setLoading(CommonConstantValues.STARTED);
    const { axiosRequest, abortController } =
      OrderService.getReturnOrderDetails(returnOrderID);
    axiosRequest
      .then(({ data }) => {
        setLoading(CommonConstantValues.DONE);
        let updatedOrderDetails = data?.responseData;
        updatedOrderDetails.statusDetails =
          ReturnOrderStatusIcons[data?.responseData?.status];
        setOrderDetails(updatedOrderDetails);
      })
      .catch((error) => {
        if (error?.message !== "canceled") {
          setLoading(CommonConstantValues.DONE);
        }
      });
    return () => abortController.abort();
  };

  const uploadBilty = (biltyFiles) => {
    setShowFileUpload(false);
    setLoading("started");
    console.log(biltyFiles);
    uploadAttachments(biltyFiles);
  };

  const uploadAttachments = (biltyFiles) => {
    let s3UploadedObjectUrls = [];
    _.map(biltyFiles, (file, index) => {
      const fileExtension = file?.fileExtension;
      const fileName = file?.file?.name
        ? `${MiscUtils.getFileName(file.file.name)}`
        : `${file.id}`;
      const { axiosRequest } = DocumentService.getAttachmentS3Url(
        fileExtension,
        fileName,
        orderDetails?.farmerId
      );
      axiosRequest
        .then((response) => {
          const s3UrlResponse = response?.data?.responseData;
          console.log(s3UrlResponse);
          if (s3UrlResponse) {
            const { axiosRequest } = DocumentService.uploadDocumentToS3(
              s3UrlResponse.presignedUrl,
              file?.file,
              file?.fileType
            );
            axiosRequest
              .then((response) => {
                s3UploadedObjectUrls.push(s3UrlResponse.objectUrl);
                console.log(s3UrlResponse.objectUrl);
                if (s3UploadedObjectUrls.length === biltyFiles.length) {
                  addBiltyForThisOrder(s3UploadedObjectUrls);
                }
              })
              .catch((error) => {
                console.log(error);
                setLoading("done");
              });
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading("done");
        });
    });
  };

  const addBiltyForThisOrder = (s3UploadedObjectUrls) => {
    console.log(s3UploadedObjectUrls);
    const commentRequestData = {
      comment: "Bilty Uploaded",
      ticketUUID: orderDetails.ticketUUID,
      s3urls: s3UploadedObjectUrls,
      documentType: "BILTY",
      orderId: parseInt(returnOrderID),
    };
    const { axiosRequest } =
      AgentService.addCommentsForTheOrder(commentRequestData);
    axiosRequest
      .then((response) => {
        if (response?.data?.message === "OK") {
          setShowToast(true);
          setToastMessage("Bilty Added Successfully");
          setLoading("done");
          getReturnOrderDetail();
        }
      })
      .catch((error) => {
        console.log(error);
        setShowToast(true);
        setToastMessage("Something went wrong");
        setLoading("done");
      });
  };

  const handleAndroidDownload = (imageUrl) => {
    if (AndroidService.checkIfAndroid()) {
      const fileName = MiscUtils.getFileName(imageUrl);
      const eventProperties = {
        page: "Return Order Details",
        returnOrderID: returnOrderID,
        imageUrl: imageUrl,
      };
      const { appVersionCode } = AndroidService.getAndroidVersion();
      if (appVersionCode >= 11) {
        AnalyticsService.pushEvent(`Attachment Clicked`, eventProperties);
        AndroidService.downloadImage(fileName, imageUrl);
      }
    }
  };

  return (
    <Box>
      <ErrorBoundary message={``}>
        <TopBar
          title={`Return Order Details`}
          backNavigation={true}
          showCart={false}
          showHisaab={true}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <BlockUi
          tag="div"
          blocking={
            loading === CommonConstantValues.STARTED &&
            loading !== CommonConstantValues.DONE
          }
          message={`Loading...`}
          style={{ minHeight: "85vh" }}
        >
          <CardContent>
            <ReturnOrderDetailCard
              order={orderDetails}
              returnOrderID={returnOrderID}
              returnOrderDetailsCart={true}
            />
          </CardContent>

          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "18px",
              marginLeft: "23px",
            }}
          >
            Items in this Order
          </Typography>

          {_.map(orderDetails?.orderItems, (itemDetails) => {
            return (
              <>
                <Grid
                  container
                  sx={{
                    margin: "10px 0px",
                    display: "flex",
                    padding: "8px",
                    height: "90px",
                    border: "1px solid #EEEEEE",
                    background: "#FFFFFF",
                  }}
                >
                  <Grid
                    item
                    xs={2}
                    sx={{
                      height: "100%",
                    }}
                  >
                    <img
                      src={itemDetails?.productImage}
                      alt=""
                      width={"100%"}
                      height="100%"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{
                      paddingLeft: "10px",
                      height: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        wordBreak: "break-all",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      {itemDetails?.productName}
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "#4F4F4F",
                      }}
                    >
                      Quantity - {itemDetails?.quantity}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            );
          })}
          {orderDetails?.biltyUrls?.length > 0 && (
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "100%" }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginLeft: "23px",
                }}
              >
                {`Attachments (${orderDetails.biltyUrls.length})`}
              </Typography>
              {_.map(orderDetails?.biltyUrls, (url, index) => {
                if (MiscUtils.checkIfImageUrl(url)) {
                  return (
                    <Box
                      sx={{
                        width: "calc(100% - 20px)",
                        position: "relative",
                        marginBottom: "10px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <Typography
                        sx={{
                          background: "#00000090",
                          padding: "6px",
                          color: "white",
                          width: "100%",
                          position: "absolute",
                          top: 0,
                          left: 0,
                          borderRadius: "10px 10px 0 0",
                        }}
                      >
                        {MiscUtils.getFileNameWithExtension(url)}
                      </Typography>
                      <img
                        key={index}
                        src={url}
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "contain",
                          borderRadius: "10px",
                        }}
                        onClick={() => {
                          handleAndroidDownload(url);
                        }}
                      />
                    </Box>
                  );
                } else {
                  return (
                    <Typography
                      sx={{
                        padding: "10px",
                        margin: "10px",
                        width: "auto",
                        background: "#00000090",
                        borderRadius: "6px",
                        color: "white",
                      }}
                      onClick={() => {
                        handleAndroidDownload(url);
                      }}
                    >
                      {MiscUtils.getFileNameWithExtension(url)}
                    </Typography>
                  );
                }
              })}
            </Box>
          )}
        </BlockUi>
        {orderDetails?.canUploadBilty && (
          <Button
            fullWidth
            className={styleClass.addBiltyButton}
            onClick={() => {
              setShowFileUpload(true);
            }}
          >
            Add Bilty
          </Button>
        )}
        <Toast
          show={showToast}
          setShow={setShowToast}
          alertText={toastMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
        <FileUploadDrawer
          showFileUpload={showFileUpload}
          setShowFileUpload={setShowFileUpload}
          uploadBilty={uploadBilty}
          page={`Return Order Detail`}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <NeedHelp title={`Need Help`} />
      </ErrorBoundary>
    </Box>
  );
}

export default ReturnOrderDetails;
